import React, { useState } from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { withRouterWorkaround } from 'utils/workaroundUtils';
import styled from 'styled-components';
import { PatientConsumerRenderProps, withPatientContext } from 'components/patient/PatientContext';
import { RouterProps } from 'react-router';
import { MediDataNotificationsDto } from 'ts-types/api.types';
import axios from 'axios';
import FullScreenPageHeader from 'components/FullScreenPageHeader';
import { Segment } from 'semantic-ui-react';
import MediDataNotificationsSearchView from 'components/medidata-notifications/MediDataNotificationsSearchView';
import MediDataNotificationsTableView from 'components/medidata-notifications/MediDataNotificationsTableView';

const ContentDiv = styled.div`
  flex: 1 1 auto;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const StyledMediDataNotificationContainer = styled(Segment.Group)`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  margin-top: 0 !important;
  background: white;

  & .ui.grid > .row {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  & .ui.grid > .row:first-child {
    padding-bottom: 1rem !important;
  }

  & .ui.grid {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
`;


interface Props extends MessageSourceProps, RouterProps, PatientConsumerRenderProps {
}

const MediDataNotificationsView = (props: Props) => {

  const {history, getMessage} = props;

  const [notificationData, setNotificationData] =
      useState({notifications: []} as Partial<MediDataNotificationsDto> | undefined);

  const [notificationLoading, setNotificationLoading] = useState(false);

  const goToHome = () => {
    history.push("/");
  };

  const onFilterNotificationData = (notificationData: Partial<MediDataNotificationsDto>) => {
    setNotificationData(notificationData);
  }

  const onNotificationLoadingChange = (isLoading: boolean) => {
    setNotificationLoading(isLoading);
  };

  return (
      <ContentDiv>
        <FullScreenPageHeader headerMessage={getMessage("header.navigation.mediDataNotifications")}
                              buttonMessage={getMessage("back")}
                              onConfirm={goToHome}
        />

        <StyledMediDataNotificationContainer>
          <MediDataNotificationsSearchView
              onFilterNotificationData={onFilterNotificationData}
              onNotificationLoadingChange={onNotificationLoadingChange}
          />
          <MediDataNotificationsTableView
              notificationData={notificationData}
              notificationLoading={notificationLoading}
              onFilterNotificationData={onFilterNotificationData}
              onNotificationLoadingChange={onNotificationLoadingChange}
          />
        </StyledMediDataNotificationContainer>
      </ContentDiv>
  );
}

export default withRouterWorkaround(withPatientContext(withMessages(MediDataNotificationsView)));
